module.exports = __webpack_public_path__ + "img/trust__down-main-3.d656f7ee.jpg";